module.exports = __webpack_public_path__ + "static/fullstack-serverless2-8cab49014c6bf2e09252eadc8b1bd84e.png";